module.exports = __webpack_public_path__ + "static/media/napoleon-0.88501ec7.png";